
export class Player{
  constructor(opts = {}){
    /** @type {string} */
    this.id = opts.id
    /** @type {string} */
    this.name = opts.name || '角色'
    /** @type {string} 表示角色現在的位置 */
    this.location = opts.location || ''
    /** @type {Object.<string, Item>} */
    this.inventoryMap = {}
    /** @type {Item[]} */
    this.inventory = opts.inventory || []
    this.inventory = this.inventory.map((obj)=>{
      let item = new Item(obj)
      if(item.id){
        this.inventoryMap[item.id] = item
      }
      return item
    })
  }
  /**
   * 增加指定的道具至道具欄
   * @param {Item} item
   */
  addItem(item){
    if(!this.inventoryMap[item.id]){
      this.inventoryMap[item.id] = item
    }else{
      this.inventoryMap[item.id].count += item.count
    }
  }
  /**
   * 增加指定的道具至道具欄
   * @param {string} item
   * @param {number} count
   */
  addItemById(id, count){
    this.addItem(new Item({
      id,
      count
    }))
  }
  /**
   * 從道具欄中移除指定數量的道具
   * @param {string} id
   * @param {number} count
   */
  spendItemById(id, count){
    let item = this.inventoryMap[id]
    if(item && item.count > count){
      item.count -= count
      if(item.count === 0){
        this.inventory.splice(this.inventory.findIndex((item2) => item.id === item2.id), 1)
        delete this.inventoryMap[item.id]
      }
      return true
    }else{
      return false
    }
  }
  hasItem(id){
    return (id in this.inventoryMap) && (this.inventoryMap[id].count > 0)
  }
  toJSON(){
    let obj = { ...this }
    delete obj.inventoryMap
    return obj
  }
}
class Item{
  constructor(opts = {}){
    /** @type {string} */
    this.id = opts.id
    this.name = opts.name || this.id
    this.count = opts.count || 1
  }
}
Player.Item = Item
export default Player
